module.exports = __webpack_public_path__ + "static/media/icomoon.43f66325.woff";